<template> 
    <div class="py-2">

        <template v-if="canSign">
            <v-alert
            colored-border
            border="left"
            color="success"
            >
                You can proceed to sign checkin contract
            </v-alert>
        </template>

        <slot v-bind="{ canSign, submit }">
          <v-btn color="primary" @click="submit" :disabled="!canSign" depressed>Sign contract</v-btn>
        </slot>
       
        <reservation-checkin-contract
            ref="contract"
            v-on="$listeners"
            :checkin="checkin"
            :reservation="reservation"
            :property="property"
            :pdfable="false"
        />
    </div>
</template>


<script>
import ReservationCheckinContract from './ReservationCheckinContract.vue'
import session from "@/domain/Reservation/Mixins/session";

export default {
    name: "ReservationContractSignature",
    mixins: [session],
    components: {
      ReservationCheckinContract
    },
    data(){
        return {
            verification: null,
            canSign: true,
        }
    },
    props: {
        reservation: Object,
        property: Object,
    },
    computed: {
      checkin() {
        return this.checkin_session.memory
      },
      setting() {
          return this.reservation ? this.reservation.setting : null;
      },
    },
  methods: {
      submit() {
        this.$refs.contract.open()
      }
  }
}
</script>